module.exports = __webpack_public_path__ + "static/media/FenceSketch.41921aa9.svg";